
































































import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Format } from "../core/helpers/formatHelper";
import { AttendanceMode } from "../core/constants";
import { isEmbedded } from "@/shared/core/embed";

import Centers from "../components/center/center.vue";
import SearchBar from "../components/listings/SearchBar.vue";
import HomeSection from "../components/home/HomeSection.vue";
import SectionPagination from "../components/pagination/SectionPagination.vue";
import ProgramPill from "../components/programs/ProgramPill.vue";
import ProgramMeta from "../components/programs/ProgramMeta.vue";
import ProgramMedia from "../components/programs/ProgramMedia.vue";
import CategorySelector from "../components/filters/CategorySelector.vue";

@Component({
  components: {
    Centers,
    SearchBar,
    HomeSection,
    SectionPagination,
    ProgramPill,
    ProgramMeta,
    ProgramMedia,
    CategorySelector,
  },
})
export default class BookingTypesPage extends Vue {
  dbBookingTypes: any = null;
  bookingTypes: any = null;
  errorMsg: string = "";
  categories: string[] = [];
  selectedCategory: string | null = null;
  activeCenter: any = null;
  pageSize: number = 4;
  searchQuery: string = "";
  currentPage: number = 1;

  get embedded() {
    return isEmbedded();
  }

  get showSearch() {
    return (
      Array.isArray(this.dbBookingTypes) && this.dbBookingTypes.length > 4
    );
  }

  async loadBookingTypes() {
    const url =
      `${Settings.HostName}/api/publicbookings/booking-types-list/` +
      this.activeCenter.id;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.model == null || !data.ok) {
      console.error("Crash getting index booking types");
      return;
    }

    if (data.model.length == 0) {
      this.errorMsg = this.$t("no data available").toString();
    }

    this.dbBookingTypes = data.model;
    if (this.dbBookingTypes.length === 1) {
      this.$router.push(this.buildUrlBooking(this.dbBookingTypes[0]));
      return;
    }
    this.bookingTypes = data.model;
    this.selectedCategory = null;
    if (!this.showSearch) {
      this.searchQuery = "";
    }
    this.setUpCategories();
  }

  async mounted() {
    new SettingsService().setPageTitle(String(this.$t("Bookings")));
  }

  @Watch("searchQuery")
  onSearchQueryChange() {
    this.currentPage = 1;
  }

  async handleCenterSelected(center) {
    this.activeCenter = center;
    this.currentPage = 1;
    this.selectedCategory = null;
    await this.loadBookingTypes();
  }

  get categoryItems() {
    if (!Array.isArray(this.categories)) {
      return [];
    }
    return this.categories.map((category) => ({
      id: category,
      name: category,
    }));
  }

  get bookingTypesPaged() {
    if (!Array.isArray(this.bookingTypesFiltered)) {
      return [];
    }
    const total = this.totalPages;
    if (this.currentPage > total) {
      this.currentPage = total;
    }
    const start = (this.currentPage - 1) * this.pageSize;
    return this.bookingTypesFiltered.slice(start, start + this.pageSize);
  }

  get bookingTypesFiltered() {
    const baseItems = Array.isArray(this.dbBookingTypes)
      ? this.dbBookingTypes
      : this.bookingTypes;
    if (!Array.isArray(baseItems)) {
      return [];
    }
    let items = baseItems;
    if (this.selectedCategory) {
      const selected = this.selectedCategory.toLowerCase();
      items = items.filter((bt: any) => {
        const category =
          bt && bt.category
            ? bt.category
                .toString()
                .trim()
                .toLowerCase()
            : "";
        return category === selected;
      });
    }
    const q = (this.searchQuery || "").trim().toLowerCase();
    if (!q) {
      return items;
    }
    return items.filter((bt: any) => {
      const rawName =
        bt && (bt.name || bt.description) ? bt.name || bt.description : "";
      const rawDesc =
        bt && bt.extendedDescription ? bt.extendedDescription : "";
      const name = rawName.toString().toLowerCase();
      const desc = rawDesc.toString().toLowerCase();
      return name.includes(q) || desc.includes(q);
    });
  }

  get totalPages() {
    if (!Array.isArray(this.bookingTypesFiltered)) {
      return 0;
    }
    const total = this.bookingTypesFiltered.length;
    return Math.max(1, Math.ceil(total / this.pageSize));
  }

  goPrevPage() {
    if (this.currentPage <= 1) return;
    this.currentPage -= 1;
    this.scrollToTop();
  }

  goNextPage() {
    if (this.currentPage >= this.totalPages) return;
    this.currentPage += 1;
    this.scrollToTop();
  }

  goToPage(page: number) {
    this.currentPage = Math.min(Math.max(page, 1), this.totalPages);
    this.scrollToTop();
  }

  getImagePath(img: string) {
    return this.$store.state.settings.Uploads + "/" + img;
  }

  attendanceLabel(bt: any): string {
    if (bt.attendanceMode === AttendanceMode.OnlineOnly) {
      return this.$t("Online").toString();
    }
    if (bt.attendanceMode === AttendanceMode.InPerson) {
      return this.$t("In person").toString();
    }
    return this.$t("In person or online").toString();
  }

  buildUrlBooking(bt: any) {
    if (bt.bookingByPlace === true || bt.byPlace === true) {
      return `/bookings-byplace/${bt.id}`;
    }
    return `/bookings/${bt.id}`;
  }

  formatCurrency(amount: string | number | null) {
    if (amount == null) {
      return "";
    }
    return Format.formatCurrency(amount as string);
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  setUpCategories() {
    this.categories = [];
    if (!Array.isArray(this.dbBookingTypes)) {
      return;
    }
    for (const bt of this.dbBookingTypes) {
      const category = bt && bt.category ? bt.category.toString().trim() : "";
      if (category === "") {
        continue;
      }
      const exists = this.categories.find(
        (entry) => entry.toLowerCase() === category.toLowerCase(),
      );
      if (exists === undefined) {
        this.categories.push(category);
      }
    }
  }

  handleCategorySelected(category: any) {
    const value = category && category.id !== undefined ? category.id : null;
    this.selectedCategory = value;
    this.currentPage = 1;
  }

  clearCategoryFilter() {
    this.selectedCategory = null;
    this.currentPage = 1;
  }
}
